<div class="modal-header">
  {{verb}} Playbook Category
  <i class="material-icons" #closebtn data-bs-dismiss="modal" (click)='closeModal()'>close</i>
</div>
<form #f="ngForm">
  <div class="fix-height-modal">
    <div class="modal-body playbook-setting">
      <div class="row form-group align-items-center">
        <label class="control-label col-sm-4" for="actionName">Category Name</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" name="actionName" [(ngModel)]="vBuilderTemplate.actionName"
            placeholder="Enter Category Name" required>
        </div>
      </div>
      <div class="row form-group align-items-center">
        <label class="control-label col-sm-4" for="tutorialLink">Tutorial Playbook</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" name="tutorialLink" [(ngModel)]="vBuilderTemplate.tutorialLink"
            placeholder="Enter Valid URL" required>
        </div>
      </div>
      <div class="row form-group align-items-center">
        <label class="control-label col-sm-4" for="actionDescription">Action Item</label>
        <div class="col-sm-8">
          <textarea class="form-control" name="actionDescription" [(ngModel)]="vBuilderTemplate.actionDescription"
          placeholder="Enter Action Item" required></textarea>
        </div>
      </div>
      <div class="row form-group align-items-center">
        <label class="control-label col-sm-4 pt-0" for="Cover Image">Custom Page Icon</label>
        <div class="col-sm-8">
          <div class="upload-image">
            <div class="upload-image-file cursor-pointer" (click)="openFileDialog()">
              @if (uploadedImg || vBuilderTemplate?.pageIconAssetId) {
                <img id="pageIcon" title="click to change file"
                  class="upload-box pointer" [src]="setImageSource()| loadSecureAssets  : true | async" alt=""
                  onerror="this.src = 'assets/img/loader.gif'" (load)="imageLoaded = true;" [hidden]="!imageLoaded" />
              }
              @if (!uploadedImg && !vBuilderTemplate?.pageIconAssetId) {
                <span class="material-icons upload-icon upload-icon-color"
                >cloud_upload</span>
              }
              <div class="file-upload hide" style="display: none;">
                <input id="customPageIcon" #fileInput (click)="fileInput.value = null" (change)="imageSelected($event)"
                  accept="image/jpg, image/jpeg, image/png" class="file-upload__input" type="file" name="preview-file-upload"
                  required>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row form-group">
        <label class="control-label col-sm-12 text-start" for="Title">Select a Page Template</label>
        <div class="col-sm-4">
          <p style="margin-bottom: 10px;">Filter by Group </p>
          <select class="multiSelect form-control" id="templateGrp" multiple (change)="filterTemplates();"
            data-native-menu="false" name="templateGroups" [(ngModel)]="selectedGroups">
            <option value="All Groups">-- All Groups --</option>
            @for (template of templateGroups; track template) {
              <option [ngValue]="template.id" [value]="template.id"
                [title]="template.name">
                {{template.name}}
              </option>
            }
          </select>
        </div>
        <div class="col-sm-8">
          <div class="row">
            <div class="multi-select-preview">
              <ul>
                @for (template of shownTemplates; track template) {
                  <li class="template-item">
                    <div class="col-lg-4 col-sm-4 col-xs-12 template-left">
                      <img [src]="setTemplateImgSrc(template) | loadSecureAssets  : true | async"
                        class="img-responsive" onerror="this.src = 'assets/img/loader.gif'" (load)="imageLoadedTemplateImg = true;"
                        [hidden]="!imageLoadedTemplateImg" loading="lazy" alt="">
                      <a class="template-title" (click)="selectTemplate(template)">
                        {{template.name}}
                      </a>
                    </div>
                    <div class="col-lg-8 col-sm-8 col-xs-12 template-right">
                      <div class="template-desc" [innerHtml]="template.description">
                      </div>
                      <button type="button" class="btn vPlaybookDefaultButton btn__btn-default select-template-btn"
                        (click)="selectTemplate(template)"
                        [ngClass]="{'btn__orange': template.id === vBuilderTemplate.pageTemplateId}">
                        {{template.id === vBuilderTemplate.pageTemplateId ? 'Selected Template' : 'Select This Template'}}
                      </button>
                    </div>
                  </li>
                }
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn vPlaybookDefaultButton btn__btn-default" data-bs-dismiss="modal" (click)='closeModal()'>Cancel</button>
    <button type="button" class="btn btn__btn-default btn__orange" (click)="savePlaybookCategory()"
      [ngClass]="{'custom-btn-disabled': f.invalid || !vBuilderTemplate.pageTemplateId}"
    [disabled]="f.invalid || !vBuilderTemplate.pageTemplateId">Save</button>
  </div>
</form>
